<script lang="ts" setup>
import { ref, Ref, computed } from "vue";
import { useApiStore, type Team } from "@/stores/api";

const apiStore = useApiStore();

const team: Ref<Team[]> = ref([]);

apiStore.getTeam().then((t: Team[]) => (team.value = t));
</script>

<template>
    <div class="grid grid-cols-2 gap-x-[30px] gap-y-[57px]">
        <div v-for="member in team">
            <img :data-src="member.acf.primary_image" class="lazyload w-full mb-[20px]" />
            <div class="text-24 mb-[8.5px] font-medium leading-[32px]">{{ member.title.rendered }}</div>
            <div class="text-15 leading-[24px] block" v-if="member.acf.function">{{ member.acf.function }}</div>
            <a class="text-15 leading-[24px] block cta-contact-info hover:underline" v-if="member.acf.tel" :href="`tel:${member.acf.tel}`">T.{{ member.acf.tel }}</a>
            <a class="text-15 leading-[24px] block cta-contact-info hover:underline" v-if="member.acf.email" :href="`mailto:${member.acf.email}`" >{{ member.acf.email }}</a>
        </div>
    </div>
</template>
